<svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 22.906 16.103">
  <defs>
    <style>.a{fill:#44454d; fill-rule:evenodd;}</style>
  </defs>
  <path class="a"
        d="M8.2,4.734A.812.812,0,0,1,9.353,5.876L3.5,11.73H22.812a.813.813,0,0,1,.82.808.824.824,0,0,1-.82.82H3.5L9.353,19.2a.829.829,0,0,1,0,1.155.809.809,0,0,1-1.154,0L.96,13.114a.814.814,0,0,1,0-1.142L8.2,4.734Z"
        transform="translate(23.632 20.595) rotate(180)"/>
</svg>
